import React from 'react'
import Button from './Button'

const ButtonNotifications = (props) => {
  return (
    <Button
      color="bar"
      icon="Notifications"
      {...props}
    />
  )
}

export default ButtonNotifications
